import { NavigateDown } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
import classNames from 'classnames';
import invariant from 'invariant';
import { forwardRef, useContext } from 'react';

import { AccordionContext } from '../Accordion.types';
import { AccordionItemContext } from '../AccordionItem/AccordionItem.types';

import styles from './AccordionTrigger.module.scss';
import { AccordionTriggerProps } from './AccordionTrigger.types';

export const AccordionTrigger = forwardRef<HTMLButtonElement, AccordionTriggerProps>(
  (
    {
      variant,
      size,
      chevronSide,
      rightElement,
      className,
      childrenClassName,
      disabled,
      children,
      ...props
    },
    ref
  ) => {
    const accordionContext = useContext(AccordionContext);
    const itemContext = useContext(AccordionItemContext);
    invariant(accordionContext, 'AccordionTrigger must be used within AccordionItem');

    return (
      <button
        className={classNames(
          styles.trigger,
          className,
          styles[variant ?? accordionContext.variant],
          styles[size ?? accordionContext.size]
        )}
        type="button"
        data-icon-size={accordionContext.size === 'small' ? 'small' : 'medium'}
        onClick={event => {
          const target = event.target as HTMLElement;
          if (
            target.matches(
              `button:not(.${styles.trigger}), button:not(.${styles.trigger}) *, a:not(.${styles.trigger}), a:not(.${styles.trigger}) *`
            )
          )
            return event.stopPropagation();
          itemContext.setIsOpen(!itemContext.isOpen);
        }}
        disabled={itemContext.disabled || disabled}
        {...props}
        ref={ref}
      >
        {(chevronSide ?? accordionContext.chevronSide) === 'left' && (
          <NavigateDown
            className={classNames(styles.chevron, { [styles.open]: itemContext.isOpen })}
          />
        )}
        <div className={classNames(styles.children, childrenClassName)}>{children}</div>
        {rightElement}
        {(chevronSide ?? accordionContext.chevronSide) === 'right' && (
          <NavigateDown
            className={classNames(styles.chevron, { [styles.open]: itemContext.isOpen })}
          />
        )}
      </button>
    );
  }
);
